import React from 'react'
import MainLayout from './MainLayout';
import ContactBody from '../components/ContactBody';

export default function ContactMe() {
    return (
        <MainLayout>
        <ContactBody/>
        </MainLayout>
    )
}
